import { PlansService } from "@/clients/services/PlansService";
import { QueryKeys } from "@/constants/query-keys";
import { recreatePlanInvalidateQueries } from "@/utils/query/invalidate";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useCreatePlan = () => {
  const queryClient = useQueryClient();
  const { mutate, mutateAsync, isPending, isError, error } = useMutation({
    mutationKey: [QueryKeys.PLAN],
    mutationFn: () => {
      const user = guardGetUserFromLocalStorage();
      return PlansService.generatePlanApiV1PlansPut(user.id);
    },
    onSuccess: () => {
      recreatePlanInvalidateQueries(queryClient);
    },
  });

  return {
    updatePlan: mutate,
    updatePlanAsync: mutateAsync,
    isLoading: isPending,
    isError,
    error,
  };
};
